"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var i18next_1 = require("i18next");
var components_1 = require("stremio/components");
var common_1 = require("stremio/common");
var Indicator_less_1 = __importDefault(require("./Indicator.less"));
var VIDEO_SCALE_KEYS = {
    'contain': 'PLAYER_SCALE_FIT',
    'cover': 'PLAYER_SCALE_CROP',
    'fill': 'PLAYER_SCALE_STRETCH',
};
var PROPERTIES = {
    'extraSubtitlesDelay': {
        label: 'SUBTITLES_DELAY',
        format: function (value) { return "".concat((value / 1000).toFixed(2), "s"); },
    },
    'videoScale': {
        label: 'VIDEO_SCALE',
        format: function (value) { return (0, i18next_1.t)(VIDEO_SCALE_KEYS[String(value)] || String(value)); },
    },
};
var Indicator = function (_a) {
    var className = _a.className, videoState = _a.videoState, disabled = _a.disabled;
    var timeout = (0, react_1.useRef)(null);
    var prevVideoState = (0, react_1.useRef)(videoState);
    var initialized = (0, react_1.useRef)(new Set());
    var _b = (0, common_1.useBinaryState)(false), shown = _b[0], show = _b[1], hide = _b[2];
    var _c = (0, react_1.useState)(null), current = _c[0], setCurrent = _c[1];
    var label = (0, react_1.useMemo)(function () {
        var property = current && PROPERTIES[current];
        return property && (0, i18next_1.t)(property.label);
    }, [current]);
    var value = (0, react_1.useMemo)(function () {
        var property = current && PROPERTIES[current];
        var value = current && videoState[current];
        return property && value && property.format(value);
    }, [current, videoState]);
    (0, react_1.useEffect)(function () {
        for (var _i = 0, _a = Object.keys(PROPERTIES); _i < _a.length; _i++) {
            var property = _a[_i];
            var prev = prevVideoState.current[property];
            var next = videoState[property];
            if (next && next !== prev) {
                if (!initialized.current.has(property)) {
                    initialized.current.add(property);
                }
                else {
                    setCurrent(property);
                    show();
                    timeout.current && clearTimeout(timeout.current);
                    timeout.current = setTimeout(hide, 1000);
                }
            }
        }
        prevVideoState.current = videoState;
    }, [videoState]);
    return (react_1.default.createElement(components_1.Transition, { when: shown && !disabled, name: 'fade', duration: 300 },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(className, Indicator_less_1.default['indicator-container']) },
            react_1.default.createElement("div", { className: Indicator_less_1.default['indicator'] },
                react_1.default.createElement("div", null,
                    label,
                    " ",
                    value)))));
};
exports.default = Indicator;
